import { useState } from 'react';
import { Alert, Box, Button, Collapse, Paper, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { initAnalytics } from '../../../analytics.config';
import { getAnalyticsConsentStatus, setAnalyticsConsentStatus } from '../legalStorage';

export default function CookieConsentBanner() {
  const [status, setStatus] = useState(getAnalyticsConsentStatus());
  const [saving, setSaving] = useState(false);

  if (status !== 'unset') {
    return null;
  }

  const handleChoice = async (accepted: boolean) => {
    setSaving(true);
    const nextStatus = accepted ? 'accepted' : 'rejected';
    setAnalyticsConsentStatus(nextStatus);
    setStatus(nextStatus);

    if (accepted) {
      await initAnalytics();
    }

    setSaving(false);
  };

  return (
    <Collapse in>
      <Box sx={{ position: 'fixed', bottom: 16, left: 16, right: 16, zIndex: 1300 }}>
        <Paper elevation={8} sx={{ p: 2.5, borderRadius: 3 }}>
          <Stack spacing={1.5}>
            <Typography variant="subtitle1" fontWeight={700}>
              Mesure d audience optionnelle
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Jacana peut utiliser Firebase Analytics pour mesurer l usage du site. Ce choix est distinct des CGV et peut etre modifie plus tard.
            </Typography>
            <Alert severity="info" variant="outlined">
              Aucun outil de mesure d audience ne devrait etre active avant votre choix explicite.
            </Alert>
            <Typography variant="body2">
              Voir la <Button component={RouterLink} to="/confidentialite" size="small">Politique de confidentialite</Button>
            </Typography>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5}>
              <Button variant="contained" onClick={() => void handleChoice(true)} disabled={saving}>
                Autoriser la mesure d audience
              </Button>
              <Button variant="outlined" onClick={() => void handleChoice(false)} disabled={saving}>
                Refuser
              </Button>
            </Stack>
          </Stack>
        </Paper>
      </Box>
    </Collapse>
  );
}